import styled from "styled-components";


export const InfoContainer = styled.div`

	background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 600px;
  position: relative;
  justify-content:center;

  :before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(
			180deg,
			rgba(0,0,0,0.5) 0%,
			rgba(0,0,0,0.5) 100%
			),
			linear-gradient(180deg, rgba(0,0,0,0.5) 0%, transparent 100%);
		z-index:2;
	}

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoBg = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
`
export const ImageBg = styled.img`
	width: 100%;
	height: 100%;
	-o-object-fit:cover;
	object-fit: cover;
	background: #232a34;
`


export const InfoContent = styled.div`
	z-index: 3;
	max-width: 1200px;
	position: absolute;
	padding: 8px 24px;
  left: 19%;
  top: 15%;
	display: flex;
	flex-direction: column;
  @media screen and (max-width: 768px) {
    right: 0%;
    bottom: 0%;
    padding: 0;
	}
`;

export const InfoH1 =styled.h1`
	color: #fff;
  font: normal normal bold 70px "Spoqa Han Sans Neo";
	
	@media screen and (max-width: 768px) {
	  font: normal normal bold 50px "Spoqa Han Sans Neo";
	}
	@media screen and (max-width: 480px) {
	  font: normal normal bold 30px "Spoqa Han Sans Neo";

	}
`

export const InfoP = styled.p`
	margin-top: 24px;
  font: normal normal 300 32px "Spoqa Han Sans Neo";
	color: #fff;

	max-width: 600px;
	
	@media screen and (max-width: 768px) {
    font: normal normal 300 24px "Spoqa Han Sans Neo";
	}

	@media screen and (max-width: 480px) {
    font: normal normal 300 20px "Spoqa Han Sans Neo";
		
	}
`

export const InfoBtnWrapper = styled.div`
	display: inline-block;
	flex-direction: column;
	align-items: center;
  @media screen and (max-width: 480px) {
	}
`
export const AnotherInfoContent =styled.div`
	z-index: 3;
	max-width: 1200px;
	position: absolute;
	padding: 8px 24px;
  left: 19%;
  top: 50%;
	display: inline-block;
	flex-direction: column;
	align-items: center;
  @media screen and (max-width: 768px) {
    right: 16%;
    bottom: 15%;
    padding: 0;
	}
`